import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { PostHogProvider } from "posthog-js/react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import { ClaimsProvider } from "@/features/auth/components/ClaimsProvider";
import { localStoragePersister, queryClient } from "@/queryClient";
import { MedibaseComponentsProvider } from "@meditect/medibase-components";
import "@meditect/medibase-components/index.css";

import App from "./App";
import { UserProvider } from "./features/auth/components/UserProvider";
import "./features/sentry/instrument";
import { SentryProvider } from "./features/sentry/SentryProvider";
import "./index.css";
import { env } from "./env";

const container = document.querySelector("#root");
const root = createRoot(container!);

root.render(
  <SentryProvider>
    <PostHogProvider
      apiKey={env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: env.REACT_APP_PUBLIC_POSTHOG_HOST,
        capture_pageview: "history_change",
        capture_exceptions: true,
        debug: process.env.NODE_ENV === "development",
        persistence: "sessionStorage",
        autocapture: {
          dom_event_allowlist: ["click"], // DOM events from this list ['click', 'change', 'submit']
          element_allowlist: ["button"], // DOM elements from this list ['a', 'button', 'form', 'input', 'select', 'textarea', 'label']
          element_attribute_ignorelist: ['aria-label="number input plus"', 'aria-label="number input minus"'],
        },
      }}
    >
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: localStoragePersister }}>
        <ClaimsProvider>
          <MedibaseComponentsProvider>
            <HelmetProvider>
              <UserProvider>
                <App />
              </UserProvider>
            </HelmetProvider>
          </MedibaseComponentsProvider>
        </ClaimsProvider>
        <ReactQueryDevtools />
      </PersistQueryClientProvider>
    </PostHogProvider>
  </SentryProvider>,
);
